import React from 'react';
import PropTypes from 'prop-types';

// import { isValidAge } from '../../utils/Room';
import PlusCircleIcon from '../icons/PlusCircleIcon';
import MinusCircleIcon from '../icons/MinusCircleIcon';

import '../../static/less/extras/extra.less';

class QuantitySelector extends React.Component {
  constructor(props) {
    super(props);

    const { maxQuantity } = props;
    this.restrictions = {
      minPaxType: 0,
      maxPaxType: maxQuantity,
    };

    this.updateControlValue = this.updateControlValue.bind(this);
  }

  isValidUpdate(control) {
    const {
      quantityNum, maxQuantity,
    } = this.props;
    const delta = control === 'min' ? -1 : 1;
    const updateValue = quantityNum + delta;

    const isValidType = this.restrictions.maxPaxType >= updateValue && updateValue > this.restrictions.minPaxType;
    const isValidTotal = quantityNum + delta <= maxQuantity;
    return isValidType && isValidTotal;
  }

  getStatusClass(control) {
    const isValidUpdate = this.isValidUpdate(control);
    return isValidUpdate ? '' : ' quantityselector__control--disabled';
  }

  updateControlValue(control) {
    const isValidUpdate = this.isValidUpdate(control);
    if (isValidUpdate) {
      const delta = control === 'min' ? -1 : 1;
      this.props.quantityUpdated(delta);
    }
  }

  renderLabel() {
    const { label } = this.props;
    return (
      <div className="quantityselector__name">
        {label}
      </div>
    );
  }

  render() {
    return (
      <div className="quantityselector">
        {this.renderLabel()}
        <div className="quantityselector__counter">
          <div className={`quantityselector__control${this.getStatusClass('min')}`}
               onClick={() => { this.updateControlValue('min'); }}>
            <MinusCircleIcon />
          </div>
          <div className="quantityselector__number">
            {this.props.quantityNum}
          </div>
          <div className={`quantityselector__control${this.getStatusClass('max')}`}
               onClick={() => { this.updateControlValue('max'); }}>
            <PlusCircleIcon />
          </div>
        </div>
      </div>
    );
  }
}

QuantitySelector.propTypes = {
  maxQuantity: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired, // PaxType for which the selector is
  quantityNum: PropTypes.number.isRequired, // Number of paxes selected for this type
  quantityUpdated: PropTypes.func.isRequired,
};

QuantitySelector.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default QuantitySelector;
